class ServiceTooltip {
    constructor() {

    }
    getHtml(services){
        let serviceHtml = "<div class='d-flex w-100 min-w-200px'>"+
            "<div class=\'me-1 flex-grow-1 flex-shrink-1 w-100 text-left\' style=\'flex-basis: 0px !important;\'><b>Type</b></div>" +
            "<div class=\'mx-1 flex-grow-1 flex-shrink-1 w-100 text-center\' style=\'flex-basis: 0px !important;\'><b>Protocol</b></div>" +
            "<div class=\'ms-1 flex-grow-1 flex-shrink-1 w-100 text-end\' style=\'flex-basis: 0px !important;\'><b>Port</b></div></div>";
        for (let service of services){
            serviceHtml += "<div class=\'separator my-1\'></div><div class='d-flex w-100 min-w-200px'>"+
                "<div class=\'me-1 flex-grow-1 flex-shrink-1 w-100 text-left\' style=\'flex-basis: 0px !important;\'>"+service['type']+"</div>" +
                "<div class=\'mx-1 flex-grow-1 flex-shrink-1 w-100 text-center\' style=\'flex-basis: 0px !important;\'>"+service['protocol']+"</div>" +
                "<div class=\'ms-1 flex-grow-1 flex-shrink-1 w-100 text-end\' style=\'flex-basis: 0px !important;\'>"+service['port']+"</div></div>";
        }
        return serviceHtml;
    }
}
window.ServiceTooltip = ServiceTooltip;